<ng-template #content><ng-content></ng-content></ng-template>
@if (href()) {
  <a [href]="href()!" [class]="class">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button (click)="click()" [class]="class">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}
